import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import apiService from "../Common/Configurations/APIService";
import config from "../Common/Configurations/APIConfig";
import TemplateCard from "./TemplateCard";
import "./TemplateGallery.css";
import UpgradeModal from "../Components/Master/UpgradeModal";

import Header from "../Common/Layout/Header";
import { useAuth } from "../Common/Configurations/AuthContext";
import WebsiteTabs from "../Components/AllTabs/WebsiteTabs";

function TemplateGallery() {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  useEffect(() => {
    if (user && !authLoading) {
      const fetchTemplates = async () => {
        try {
          const response = await apiService.getAll(config.GETALLTEMPLATES);
          setTemplates(response.data);
        } catch (error) {
          // Error is handled by apiService
        } finally {
          setLoading(false);
        }
      };
      fetchTemplates();
    } else if (!authLoading) {
      navigate("/login");
    }
  }, [user, authLoading, navigate]);

  const handlePreview = (templateId) => {
    window.open(`/template-preview/${templateId}`, "_blank");
  };

  const handleSelect = (templateId) => {
    // Define which plans are allowed to use templates
    const allowedPlans = ["PRO", "ENTERPRISE"]; // Use the exact names from your backend

    if (user && allowedPlans.includes(user.planType?.toUpperCase())) {
      // If the user has an allowed plan, proceed with the selection
      alert(
        `You selected template ID: ${templateId}. Ready for the next step!`
      );
      // TODO: Here you would call the API to assign the template to the company.
    } else {
      // If the user does not have an allowed plan, show the upgrade modal
      setShowUpgradeModal(true);
    }
  };

  // --- THIS IS THE KEY CHANGE ---
  // Re-introduce the full-page loading check, just like in LandingPage.js
  if (authLoading || loading) {
    // You can use a more sophisticated spinner component here if you have one
    return <p>Loading...</p>;
  }

  // By the time we get here, both auth and templates are loaded.
  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="card">
              <div className="p-2">
                <WebsiteTabs pageName="WEBSITETEMPLATES" />
              </div>
              <div className="card-body">
                {/* No more loading check needed inside here for initial load */}
                <div className="row">
                  {templates.length > 0 ? (
                    templates.map((template) => (
                      <TemplateCard
                        key={template.templateId}
                        template={template}
                        onPreview={() => handlePreview(template.templateId)}
                        onSelect={() => handleSelect(template.templateId)}
                      />
                    ))
                  ) : (
                    <p className="text-center">No templates available.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <UpgradeModal
        show={showUpgradeModal}
        handleClose={() => setShowUpgradeModal(false)}
      />
    </div>
  );
}

export default TemplateGallery;
